export default "__VITE_ASSET__BQaN39R2__"